module.exports = __webpack_public_path__ + "img/s_top_05.7ffcb654.png";